module.exports = __webpack_public_path__ + "img/car.660ce57f.png";